import React from 'react';
import { CalendarCheck } from 'lucide-react';

const FloatingBookButton = () => {
  const handleClick = () => {
    window.open('https://zcal.co/dibum/30min', '_blank');
  };

  return (
    <div className="fixed bottom-[160px] right-6 z-50">
      <button
        onClick={handleClick}
        className="group relative flex items-center h-14 w-14 md:hover:w-40 rounded-full bg-gradient-to-br from-blue-600 via-violet-600 to-pink-500 text-white shadow-2xl shadow-violet-500/40 hover:shadow-violet-500/60 transition-all duration-300 overflow-hidden"
        aria-label="Book a free consultation call"
      >
        {/* Icon — always visible, fixed width so it stays centered when collapsed */}
        <span className="flex items-center justify-center w-14 h-14 flex-shrink-0">
          <CalendarCheck className="w-6 h-6" />
        </span>

        {/* Label — only visible on desktop hover */}
        <span className="hidden md:block pr-5 text-sm font-semibold whitespace-nowrap opacity-0 md:group-hover:opacity-100 transition-opacity duration-150 delay-100">
          Book a Call
        </span>

        <span className="absolute inset-0 rounded-full bg-violet-500 animate-ping opacity-20 pointer-events-none" />
      </button>
    </div>
  );
};

export default FloatingBookButton;
